/* eslint eqeqeq: "off" */
import React, { useEffect, useState } from "react";
import { Col, Collapse, Input, Row } from "antd";

// import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import {
  CloseCircleOutlined,
  DownOutlined,
  SearchOutlined,
} from "@ant-design/icons";
import { loadPackagesFaqMainList } from "../../store/packages/actions";
import { useDispatch, useSelector } from "react-redux";
import useMedia from "use-media-antd-query";
import { debounce } from "lodash";

const Question = () => {
  const dispatch = useDispatch();
  const media = useMedia();
  useEffect(() => {
    dispatch(loadPackagesFaqMainList());

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  const { packages_faq_main_list = [] } = useSelector(
    (state) => state.Packages
  );
  const packageFaqMainList =
    packages_faq_main_list &&
    packages_faq_main_list &&
    packages_faq_main_list.length > 0
      ? packages_faq_main_list
          .filter((faq) => faq.parentType == "package")
          .map((data, index) => {
            return {
              key: index + 1,
              label: `Q. ${data.question}?`,
              question: data.question,
              children: (
                <div>
                  {data.answer ? (
                    <div
                      dangerouslySetInnerHTML={{
                        __html: data.answer ? data.answer : "",
                      }}
                      className="text-[12px] font-normal"
                    ></div>
                  ) : (
                    <p className="text-[12px] text-center font-normal">
                      {"No data found.."}
                    </p>
                  )}
                </div>
              ),
            };
          })
      : [];

  const [query, setQuery] = useState("");
  const [filteredSuggestions, setFilteredSuggestions] = useState([]);
  useEffect(() => {
    if (packageFaqMainList && packageFaqMainList.length > 0) {
      setFilteredSuggestions(packageFaqMainList);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [packages_faq_main_list]);
  const handleChange = debounce((e) => {
    const userInput = e.target.value.toLowerCase();

    const filtered = packageFaqMainList
      .filter((row) => row.question.toLowerCase().includes(userInput))
      .filter(
        (item, index, self) =>
          index === self.findIndex((t) => t.question === item.question)
      );
    setFilteredSuggestions(userInput !== "" ? filtered : packageFaqMainList);

    setQuery(e.target.value);
  }, 300);

  return (
    <Col md={24} lg={24} xl={24} xxl={24} className="rounded-sm p-4">
      <Row className="relative">
        <Col
          md={24}
          lg={24}
          xl={24}
          xxl={24}
          sm={24}
          xs={24}
          className="pr-5 pt-1 pb-3"
        >
          <div
            style={{
              fontFamily: "Poppins",
              marginBottom: "1rem",
              width: "100%",
              //   boxShadow: "1px 1px 1px 2px lightgray",
            }}
          >
            <div className="flex text-[24px] font-extrabold text-start ml-[50px]">
              <h2 className="">Frequently Asked Questions(FAQ)</h2>
              {/* <span className="ml-1">of Booking With Us</span> */}
            </div>
          </div>
        </Col>
        <Col
          md={24}
          lg={24}
          xl={24}
          xxl={24}
          sm={24}
          xs={24}
          className={
            media === "xxl"
              ? "pr-5 pb-3 absolute top-[-216px] left-[40%]"
              : media === "xl" || media === "lg"
              ? "pr-5 pb-3 absolute top-[-216px] left-[36%]"
              : media === "md"
              ? "pr-5 pb-3 absolute top-[-170px] left-[37%]"
              : "pr-5 pb-3 absolute top-[-170px] left-[33%]"
          }
        >
          {" "}
          <Row
            className={
              media == "xs" || media == "sm"
                ? "flex w-[110%]"
                : media == "md" || media == "lg"
                ? "flex w-[144%]"
                : media == "xl"
                ? "flex w-[158%]"
                : "flex justify-center w-[170%]"
            }
          >
            <div className={"mt-[-8px] w-[110%]"}>
              <h1
                style={{
                  fontFamily: "Poppins",
                }}
                className="text-[16px] text-center font-semibold text-[white] mb-2"
              >
                How Can we help ?
              </h1>
              <Input
                size={media == "sm" || media == "xs" ? "small" : "large"}
                placeholder="Search the FAQ!"
                style={{
                  border: "0.5px solid lightgray",
                  padding:
                    media == "sm" || media == "xs"
                      ? "6px 10px"
                      : media == "md"
                      ? "6px 10px"
                      : "10px",
                  // width: media == "sm" || media == "xs" ? "" : "w-[75%]",
                  borderRadius: "22px",
                  fontSize: media == "sm" || media == "xs" ? "14px" : "17px",
                }}
                className="w-[100%] border input-label rounded-xl shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-400 transition"
                prefix={
                  <SearchOutlined
                    className={
                      media == "sm" || media == "xs"
                        ? "text-[14px] mr-2"
                        : "text-[20px] mr-2"
                    }
                  />
                }
                suffix={
                  query !== "" ? (
                    <CloseCircleOutlined
                      onClick={() => {
                        setQuery("");
                        setFilteredSuggestions(packageFaqMainList);
                      }}
                    />
                  ) : (
                    ""
                  )
                }
                name="query"
                value={query}
                onChange={handleChange}
              />
            </div>
          </Row>
        </Col>
        <Col
          md={24}
          lg={24}
          xl={24}
          xxl={24}
          sm={24}
          xs={24}
          className="pr-[45px] pl-[45px] pb-3"
        >
          <div className="w-[100%]">
            {filteredSuggestions.length > 0 ? (
              <Collapse
                items={
                  filteredSuggestions.length > 0 ? filteredSuggestions : []
                }
                expandIcon={<DownOutlined />}
                expandIconPosition="right"
                className="font-semibold text-[16px] border-none"
                style={{
                  fontFamily: "Poppins",
                  background: "none",
                }}
                //   bordered
                bordered={false}
              />
            ) : (
              <div
                style={{
                  fontFamily: "Poppins",
                }}
                className="w-[100%] text-[18px] font-normal flex justify-center"
              >
                No Faq found..
              </div>
            )}
          </div>
        </Col>
      </Row>
    </Col>
  );
};

export default Question;
